import { useState, useContext ,useEffect} from "react";
import { RegularButton, CustomButton, } from "../../../common/ReusableComponent/CustomButton";
import { ReusableInput, SelectInput } from "../../../common/ReusableComponent/ReusableInput";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
import ReusableModal from "../../AppPAges/ManageSettings/ReusableModal";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../common/ToastHandler";
import "./AssetsRequest.css";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import AddVendorModal from "../../AppPAges/ReusableForm/AddVendorModal";
import StatusPill from "../../../common/ReusableComponent/StatusPill";
import ActionButton from "../../../common/ReusableComponent/ActionButton";
import { FaTools } from "react-icons/fa";
import { ToastContainer } from "react-toastify";

const AssetsRequest = () => {
  const { GetPaginatedData, Post } = useApi();
  const { handleToast } = useToastHandler();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [refreshTable, setRefreshTable] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showMaintenanceModal, setshowMaintenanceModal] = useState(false);
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [selectedRequestUserName, setSelectedRequestUserName] = useState("");
  const [selectedMaintenanceUserName, setSelectedMaintenanceUserName] = useState("");
  const [setSelectedAssetName] = useState("");
  const [setSelectedVendorName] = useState("");
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [formData, setFormData] = useState({
    category: "",
    description: "",
    request_to: "",
  });

  const [formMaintenanceData, setFormMaintenanceData] = useState({
    asset: "",
    maintenance_type: "",
    issue_description: "",
    remarks: "",
    assigned_to: "",
    assigned_to_name: "",
    vendor: "",
    vendor_name: "",
    reported_at: new Date().toISOString().split("T")[0],
  });

  const [errors, setErrors] = useState({
    asset: "",
    maintenance_type: "",
    assigned_to: "",
    issue_description: "",
    remarks: "",
  });

  const fetchAssetRequests = async ({ page = 1, searchTerm = "", sort = "", order = "" }) => {
    try {
      const response = await GetPaginatedData("myRequests", {
        page,
        search: searchTerm,
        sort,
        order,
      });
      return response;
    } catch (error) {
      console.error("Failed to fetch asset requests:", error);
      return { data: [], totalPages: 1 };
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleCreateAssetRequest = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      category: formData.category,
      description: formData.description.trim(),
      store: user.store,
      store_name: user.store_name,
      request_from: user.user_id,
      request_from_name: user.user_name || null,
      request_to: formData.request_to,
      request_to_name: selectedRequestUserName || null,
      is_request_active: true,
    };

    try {
      setLoading(true);
      const response = await Post("assetRequest", payload);

      handleToast({
        type: "SUCCESS",
        message: response?.data?.message || "Asset request submitted successfully",
      });

      resetForm();
      setRefreshTable(prev => prev + 1);
      setShowModal(false);
    } catch (error) {
      handleToast({
        type: "ERROR",
        message: "Failed to submit asset request",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMaintenanceChange = (e) => {
    const { name, value } = e.target;

    let processedValue = value;
    if (name === "issue_description" || name === "remarks") {
      processedValue = capitalizeFirstLetter(value);
    }

    setFormMaintenanceData({
      ...formMaintenanceData,
      [name]: processedValue,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "issue_description") {
      if (!value.trim()) {
        error = "Issue description is required";
      } else if (value.length > 500) {
        error = "Issue description must not exceed 500 characters";
      }
    }

    if (name === "remarks" && value && value.length > 300) {
      error = "Remarks must not exceed 300 characters";
    }

    setErrors({
      ...errors,
      [name]: error,
    });
  };

  const handleMaintenanceRequest = async (e) => {
    e.preventDefault();

    if (!validateMaintenanceForm()) return;

    const payload = {
      asset: selectedAssetId,
      maintenance_type: formMaintenanceData.maintenance_type,
      issue_description: formMaintenanceData.issue_description,
      remarks: formMaintenanceData.remarks,
      assigned_to: Number(formMaintenanceData.assigned_to),
      assigned_to_name: selectedMaintenanceUserName || null,
      reported_at: formMaintenanceData.reported_at || new Date().toISOString(),
      store: user.store,
      reported_by: user.user_id,
      reported_by_name: user.user_name || null,
      status: "reported",
    };

    try {
      setLoading(true);

      const response = await Post("assetMaintenance", payload);

      handleToast({
        type: "SUCCESS",
        message: response?.data?.message || "Maintenance request submitted successfully",
      });

      setshowMaintenanceModal(false);
      setRefreshTable(prev => prev + 1);
      resetMaintenanceForm();
      setSelectedAssetName("");
      setSelectedMaintenanceUserName("");

      setSelectedVendorName("");
    } catch {
      handleToast({
        type: "ERROR",
        message: "Failed to submit maintenance request",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseMaitenanceModal = () => {
    setshowMaintenanceModal(false);
    resetMaintenanceForm();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateMaintenanceForm = () => {
    let hasErrors = false;
    const newErrors = { ...errors };

    if (!formMaintenanceData.maintenance_type) {
      newErrors.maintenance_type = "Maintenance type is required";
      hasErrors = true;
    }
    if (!formMaintenanceData.assigned_to) {
      newErrors.assigned_to = "Assigned to is required";
      hasErrors = true;
    }
    if (!formMaintenanceData.issue_description?.trim()) {
      newErrors.issue_description = "Issue description is required";
      hasErrors = true;
    }

    setErrors(newErrors);
    return !hasErrors;
  };
  const validateForm = () => {
    if (!formData.category) {
      handleToast({ type: "ERROR", message: "Category is required" });
      return false;
    }
    if (!formData.description.trim()) {
      handleToast({ type: "ERROR", message: "Description is required" });
      return false;
    }
    if (!formData.request_to) {
      handleToast({ type: "ERROR", message: "Request To is required" });
      return false;
    }
    return true;
  };



  const resetForm = () => {
    setFormData({
      category: "",
      description: "",
      request_to: "",
    });
    setSelectedCategoryName("");
    setSelectedRequestUserName("");

  };

  const handleCloseModal = () => {
    setShowModal(false);
    resetForm();
  };
  const resetMaintenanceForm = () => {
    setFormMaintenanceData({
      asset: "",
      maintenance_type: "",
      issue_description: "",
      remarks: "",
      assigned_to: "",
      assigned_to_name: "",
      vendor: "",
      vendor_name: "",
      reported_at: new Date().toISOString().split("T")[0],
    });

    setErrors({
      asset: "",
      maintenance_type: "",
      assigned_to: "",
      issue_description: "",
      remarks: "",
    });

    setSelectedAssetId(null);
  };

  const REQUEST_STATUS_PILL = {
    pending: {
      bg: "#fff7ed",
      text: "#c2410c",
      border: "#fed7aa",
    },

    approved: {
      bg: "#ecfdf3",
      text: "#027a48",
      border: "#a6f4c5",
    },

    allocated: {
      bg: "#eff6ff",
      text: "#1d4ed8",
      border: "#bfdbfe",
    },

    rejected: {
      bg: "#fef2f2",
      text: "#b91c1c",
      border: "#fecaca",
    },

    returned: {
      bg: "#f8fafc",
      text: "#475569",
      border: "#cbd5e1",
    },

    maintenance_approved: {
      bg: "#ecfeff",
      text: "#0f766e",
      border: "#99f6e4",
    },

    "maintenance reported": {
      bg: "#fdf4ff",
      text: "#86198f",
      border: "#f5d0fe",
    },

    maintenance_in_progress: {
      bg: "#f0f9ff",
      text: "#0369a1",
      border: "#bae6fd",
    },

    "under maintenance": {
      bg: "#fffbeb",
      text: "#b45309",
      border: "#fde68a",
    },
  };


  const tableColumns = [
    {
      header: "Asset Name",
      field: "asset_name",
      render: (item) => {
        return item.asset_name && item.asset_name.trim()
          ? item.asset_name
          : "Not Allocated";
      },
    },
    { header: "Category", field: "category" },
    { header: "Description", field: "description" },
    { header: "Request From", field: "request_from_name" },
    { header: "Request To", field: "request_to_name" },

    {
      header: "Requested Date",
      field: "request_date",
      render: (item) => {
        if (item.request_date) {
          return new Date(item.request_date).toLocaleDateString();
        }
        return '-';
      }
    },
    {
      header: "Allocation Date",
      field: "allocation_date",
      render: (item) => {
        if (item.allocation_date) {
          return new Date(item.allocation_date).toLocaleDateString();
        }
        return '-';
      }
    },
    {
      header: "Return Date",
      field: "return_date",
      render: (item) => {
        if (item.return_date) {
          return new Date(item.return_date).toLocaleDateString();
        }
        return '-';
      }
    },
    {
      header: "Status",
      render: (item) => {
        const status = (item.status || "pending").toLowerCase();
        const cfg =
          REQUEST_STATUS_PILL[status] ||
          REQUEST_STATUS_PILL.pending;

        return (
          <StatusPill
            label={status.replace(/_/g, " ")}
            bgColor={cfg.bg}
            textColor={cfg.text}
            borderColor={cfg.border}
          />
        );
      },
    },
    {
      header: "Rejection Reason",
      field: "reason_for_rejection",
      render: (item) => {
        if ((item.status || "").toLowerCase() === "rejected") {
          return item.reason_for_rejection || "-";
        }
        return "-";
      }
    },

    {
      header: "Maintenance",
      render: (item) => {
        if (item.status === "allocated") {
          return (
            <ActionButton
              onClick={() => {
                setSelectedAssetId(item.asset_id);
                setshowMaintenanceModal(true);
              }}
              bgColor="#fff7ed"
              textColor="#ea580c"
              borderColor="#fed7aa"
              hoverBgColor="#ffedd5"
            >
              <FaTools />
              Request Maintenance
            </ActionButton>
          );
        }

        return "-";
      },
    },
  ];



  return (
    <div className="responsive-box">
      <div className="inventory-header">
        <div className="inventory-title">Asset Request</div>
        <CustomButton
          text="Asset Request"
          onClick={() => setShowModal(true)}
          color="#000000"
          backgroundColor="#FFAF32"
          iconPosition="right"
        />
      </div>

      <ReusableTable
        columns={tableColumns}
        fetchData={fetchAssetRequests}
        enablePagination={true}
        refreshKey={refreshTable}
      />

      <ReusableModal
        title="Asset Request"
        show={showModal}
        handleClose={handleCloseModal}
        width="500px"
        height="450px"
      >
        <form onSubmit={handleCreateAssetRequest}>
          <div className="d-flex flex-column mx-3">
            <div className="mb-3">
              <label className="form-label">Category <span style={{ color: 'red' }}>*</span></label>
              <PaginatedSearchSelect
                api="category"
                GetPaginatedData={GetPaginatedData}
                getOptionLabel={(opt) => opt?.category_name}
                onSelect={(opt) => {
                  setFormData((prev) => ({
                    ...prev,
                    category: opt?.id || "",
                  }));
                  setSelectedCategoryName(opt?.category_name || "");
                }}
                value={
                  formData.category
                    ? {
                      id: formData.category,
                      category_name: selectedCategoryName,
                    }
                    : null
                }
                placeholder="Choose asset category"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Request To <span style={{ color: 'red' }}>*</span></label>
              <PaginatedSearchSelect
                api="user"
                GetPaginatedData={GetPaginatedData}
                getOptionLabel={(opt) => {
                  const fullName = `${opt?.first_name || ''} ${opt?.last_name || ''}`.trim();
                  return fullName || opt?.username || 'Unknown';
                }}
                filterFn={(opt) => opt?.ms_role_name === "store owner" || opt?.ms_role_name === "store manager"}
                onSelect={(opt) => {
                  setFormData((prev) => ({
                    ...prev,
                    request_to: opt?.id || "",
                  }));
                  const fullName = `${opt?.first_name || ''} ${opt?.last_name || ''}`.trim();
                  setSelectedRequestUserName(fullName || opt?.username || "");
                }}
                value={
                  formData.request_to
                    ? { id: formData.request_to, first_name: selectedRequestUserName.split(' ')[0], last_name: selectedRequestUserName.split(' ')[1] }
                    : null
                }
                placeholder="Select User"
                required
              />
            </div>

            <div className="mb-3">
              <ReusableInput
                type="textarea"
                name="description"
                label="Description"
                value={formData.description}
                onChange={handleChange}
                rows={4}
                required
              />
            </div>

            <div className="d-flex justify-content-end mt-3">
              <RegularButton
                text="Clear"
                onClick={resetForm}
                backgroundColor="#ffffff"
                color="#282E26"
              />
              <RegularButton
                text={loading ? "Submitting..." : "Submit"}
                type="submit"
                backgroundColor="#282e26"
                disabled={loading}
              />
            </div>
          </div>
        </form>
      </ReusableModal>
      <ReusableModal
        title={"Maintenance Request"}
        show={showMaintenanceModal}
        handleClose={handleCloseMaitenanceModal}
        width="550px"
      >
        <form onSubmit={handleMaintenanceRequest}>
          <div
            className="d-flex flex-column"
            style={{
              marginLeft: "0px",
              marginRight: "0px",
            }}
          >
            <div className="d-flex align-items-center mx-3">

              <div className="d-flex align-items-center mt-4">
                <div className="d-flex flex-column" style={{ width: "250px" }}>
                  <SelectInput
                    value={formMaintenanceData.maintenance_type}
                    onChange={(e) => {
                      setFormMaintenanceData((prev) => ({
                        ...prev,
                        maintenance_type: e.target.value,
                      }));
                      if (errors.maintenance_type) {
                        setErrors((prev) => ({ ...prev, maintenance_type: "" }));
                      }
                    }}
                    options={[
                      { id: "repair", name: "Repair" },
                      { id: "service", name: "Service" },
                      { id: "inspection", name: "Inspection" },
                    ]}
                    label="Maintenance Type"
                    placeholder="Select Maintenance Type"
                    required
                    style={{ width: "250px" }}
                    error={errors.maintenance_type}
                  />
                  {errors.maintenance_type && (
                    <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                      {errors.maintenance_type}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-start mb-3 mx-3">
              <div className="d-flex flex-column" style={{ width: "250px" }}>
                <PaginatedSearchSelect
                  api="user"
                  GetPaginatedData={GetPaginatedData}
                  getOptionLabel={(opt) => {
                    const fullName = `${opt?.first_name || ''} ${opt?.last_name || ''}`.trim();
                    return fullName || opt?.username || 'Unknown';
                  }}
                  filterFn={(opt) => opt?.ms_role_name === "store owner" || opt?.ms_role_name === "store manager"}
                  onSelect={(opt) => {
                    const fullName = `${opt?.first_name || ''} ${opt?.last_name || ''}`.trim();
                    setFormMaintenanceData((prev) => ({
                      ...prev,
                      assigned_to: opt?.id || "",
                      assigned_to_name: fullName || opt?.username || "",
                    }));
                    setSelectedMaintenanceUserName(fullName || opt?.username || "");

                    if (errors.assigned_to) {
                      setErrors((prev) => ({ ...prev, assigned_to: "" }));
                    }
                  }}
                  value={
                    formMaintenanceData.assigned_to && selectedMaintenanceUserName
                      ? {
                        id: formMaintenanceData.assigned_to,
                        first_name: selectedMaintenanceUserName.split(' ')[0],
                        last_name: selectedMaintenanceUserName.split(' ')[1] || '',
                      }
                      : null
                  }

                  placeholder="Assign To *"
                  required
                  style={{ width: "250px" }}
                  error={errors.assigned_to}
                />
                {errors.assigned_to && (
                  <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                    {errors.assigned_to}
                  </div>
                )}
              </div>

            </div>
            <div className="d-flex align-items-center mb-3 mx-3">
              <ReusableInput
                type="text"
                name="issue_description"
                label="Issue Description"
                value={formMaintenanceData.issue_description}
                onChange={handleMaintenanceChange}
                onBlur={handleBlur}
                maxLength={500}
                error={errors.issue_description}
                width={"600px"}
                required
              />
              <ReusableInput
                type="text"
                label="Remarks"
                name="remarks"
                value={formMaintenanceData.remarks}
                onChange={handleMaintenanceChange}
                onBlur={handleBlur}
                maxLength={300}
                error={errors.remarks}
              />
            </div>
            <div className="d-flex align-items-center mb-3 mx-3">
              <div>
                <ReusableInput
                  type="date"
                  className="mt-2"
                  value={formMaintenanceData.reported_at}
                  onChange={(e) =>
                    setFormMaintenanceData((prev) => ({
                      ...prev,
                      reported_at: e.target.value,
                    }))
                  }
                />
              </div>

            </div>
            <div className="d-flex justify-content-end mt-3">

              <RegularButton
                text="Clear"
                onClick={resetMaintenanceForm}
                backgroundColor="#ffffff"
                color="#282E26"
              />

              <RegularButton
                type="submit"
                text={loading ? "Submitting..." : "Submit"}
                backgroundColor="#282e26"
                disabled={loading}
              />
            </div>
          </div>
        </form>
      </ReusableModal>
      {showVendorModal && (
        <AddVendorModal
          show={showVendorModal}
          handleClose={() =>
            setShowVendorModal(false)
          }
        />
      )}
      <ToastContainer />
    </div>
  );
};

export default AssetsRequest;